/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["sidebar-action-buttons{display:block;text-align:center}sidebar-action-buttons .new-folder-button{max-width:60px;min-width:auto}"];
export { styles as styles };
